import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import { Skeleton } from "primereact/skeleton";
import EmptyDataView from "./EmptyDataView";
import officers from "../../../assets/images/officers.png";
import attorney from "../../../assets/images/attorney.png";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const OfficersAndPowerOfAttornyTable = ({
  data,
  loading,
  page,
  rows,
  totalRecords,
  onPageChange,
  isDataAvailable,
  type,
  isUserRegestered,
  sortMeta,
  onSort,
  handleNavigate,
}) => {
  const skeletonRows = [...Array(5)];
  return (
    <div>
      {isDataAvailable || isUserRegestered ? (
        <DataTable
          value={loading ? skeletonRows : data}
          className="datatable-right-align"
          lazy
          paginator={totalRecords > 10}
          first={page * rows}
          rows={rows}
          totalRecords={totalRecords}
          onPage={onPageChange}
          rowsPerPageOptions={[10, 20, 30]}
          sortMode="multiple"
          multiSortMeta={sortMeta}
          onSort={onSort}
          emptyMessage="No results were found"
        >
          <Column
            header="Full Name"
            sortField="name"
            sortable
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <Link
                  className="officer__link"
                  to={
                    type === "officer"
                      ? `/officers/${data?.id}/info`
                      : `/powers-of-attorney/${data?.id}/info`
                  }
                >
                  {data?.preferred_name
                    ? data?.preferred_name
                    : `${data?.name} ${data?.other_name} ${data?.last_name}`}
                </Link>
              )
            }
          />
          <Column
            header="Role"
            sortField="role"
            sortable
            body={(data) => (loading ? <Skeleton width="100%" /> : data.role)}
          />
          <Column
            header="Contact Email"
            body={(data) => (loading ? <Skeleton width="100%" /> : data?.email)}
          />
          <Column
            header="Phone Number"
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <span>
                  {data?.phone_code} {data?.phone}
                </span>
              )
            }
          />
          <Column
            header="Last Edited"
            sortField="updatedAt"
            sortable
            className="user__role--col"
            style={{ minWidth: "164px" }}
            body={(data) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                format(data?.updatedAt, "MMMM do, yyyy")
              )
            }
          />
        </DataTable>
      ) : (
        <EmptyDataView
          handleNavigate={handleNavigate}
          Icon={
            <img
              className="users-card-icon-img"
              src={type === "officer" ? officers : attorney}
              alt="Users Icon"
            />
          }
          Header={
            type === "officer"
              ? "No Officers registered yet"
              : "No Attorney's registered yet"
          }
          Description={"Let's add your first one"}
          type={type}
        />
      )}
    </div>
  );
};

export default OfficersAndPowerOfAttornyTable;
